module.exports = __webpack_public_path__ + "media/Werbung_Creamy_Chocolate.7a88a1c1.mp3";